import { Menu } from "../modules/common/menu/models/menu";
import { menuList } from "../modules/common/menu/models/menulist";

export class MenuUtils {
    public static getMenuItem(menuName: string): Menu {
        return menuList.find(menuItem => menuItem.name.toLowerCase() == menuName.toLowerCase());
    }
}